// extracted by mini-css-extract-plugin
export var section = "features-module--section--xJ46q";
export var inner = "features-module--inner--xSFs7";
export var jsAnimInit = "features-module--jsAnimInit--e1AVK";
export var head = "features-module--head--1lZHa";
export var links = "features-module--links--25pmD";
export var subtitle = "features-module--subtitle--2vESG";
export var title = "features-module--title--3AAoJ";
export var tiles = "features-module--tiles--1XiGj";